import { initializeOtelBaggage } from "@weps/shared-http";
import { environment } from "@environments/environment";

export { initializeOtelBaggage };

export function initializeAppOtelBaggage(): void {
  initializeOtelBaggage(environment.internal);
}
